import { useAddressStore } from '@features/shipping-methods'

import useDeliveryModal from '@widgets/modal-delivery/ui/useDeliveryModal'


export default function useAddress (onCallback?: () => void) {
  const { selectedAddress } = useAddressStore()
  const { openDeliveryModal } = useDeliveryModal()

  return () => {
    if (!selectedAddress) {
      openDeliveryModal()
      return
    }

    if (onCallback) {
      onCallback()
    }
  }
}
